import { Grid, Paper, TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api from '../../../services/api';
import { handleErrorRequest } from '../../../utils/errorsValidation';
import * as S from './styles';
import ReactCodeInput from 'react-verification-code-input';

const needAnswer = {
  Nao: false,
  Sim: true,
};

const RefuseConclusion = ({ data, setResponseMessage }) => {
  const maxLength = data?.mensagemDigitosMaximo ?? 250;

  const [motiveValue, setMotiveValue] = useState('');
  const [otherMotive, setOtherMotive] = useState('');
  const [getErros, setErros] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showTextfield, setShowTextfield] = useState(false);
  const [minLength, setMinLength] = useState(20);
  const [code, setCode] = useState('');
  const [formValues, setFormValues] = useState({});

  const onChange = (event) => {
    setCode(event);
  };

  const handleChange = (event) => {
    setMotiveValue(Number(event.target.value));
    const foundData = data.motivosRecusas.find(
      (el) => el.motivoRecusaId === Number(event.target.value),
    );
    setShowTextfield(needAnswer[foundData.solicitaResposta]);
    setMinLength(foundData.quantidadeMinimaDigitos);
  };

  const saveForm = async (formData) => {
    setIsLoading(true);
    try {
      const response = await api.put('OperacoesAntecipacoes/ConcluirAntecipacao', formData);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Proposta recusada com sucesso!');
        setResponseMessage(response.data.resposta.mensagem);
      } else {
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      toast.error(error.response);
    }
    setIsLoading(false);
  };

  const handleSubmit = () => {
    if (data.solicitarCodigoAutenticacao && code.length < 4) {
      return toast.error('Campo autenticação obrigatório!');
    }
    const formData = {
      antecipacaoId: data?.antecipacaoId,
      ancoraId: data.ancoraId,
      antecipacaoCodigoAutenticacaoId: data.antecipacaoCodigoAutenticacaoId,
      fornecedorId: data.fornecedorId,
      fornecedorContaBancariaId: data.fornecedorContaBancariaId,
      dataAtualizacao: data.dataAtualizacao,
	    codigoAutenticacaoDigitado: code || '0000',
      conclusao: data.conclusao,
      respostaDoFornecedor: showTextfield ? otherMotive.trim() : '',
      antecipacaoMotivoRecusaId: motiveValue,
      fornecedoresContasBancarias: null,
	    origemAprovacao: data.origemAprovacao
    };
    saveForm(formData);
  };


  return (
		<S.RefuseContainer>
			<S.InfoContainer>
				<Grid container style={{ padding: "15px" }}>
					<FormControl component="fieldset">
						<FormLabel component="legend">Motivo recusa:</FormLabel>
						<RadioGroup value={motiveValue} onChange={handleChange}>
							{data.motivosRecusas.map((option) => (
								<FormControlLabel
									key={option?.motivoRecusaId}
									value={option?.motivoRecusaId}
									control={<Radio />}
									label={option?.motivoRecusa}
								/>
							))}
						</RadioGroup>
					</FormControl>
				</Grid>

				{showTextfield ? (
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<S.InputLabel>
								Informe o motivo da sua recusa no campo abaixo:
							</S.InputLabel>
							<Paper elevation={0} className="select-paper">
								<TextField
									multiline
									rows={5}
									InputProps={{ disableUnderline: true }}
									inputProps={{ maxLength: maxLength, minLength: minLength }}
									value={otherMotive}
									onChange={(e) => setOtherMotive(e.target.value)}
									helperText={`${
										Number(data?.mensagemDigitosMaximo) - otherMotive.trim().length
									} caracteres restantes`}
								/>
							</Paper>
							{otherMotive.trim().length < minLength && (
								<S.ErrorMessage>
									Quantidade mínima de caracteres: {minLength}
								</S.ErrorMessage>
							)}
						</Grid>
					</Grid>
				) : (
					<></>
				)}
				{/* <Grid container>
					<Grid item xs={8} style={{ textAlign: "left", paddingLeft: "10px" }}>
						<S.ActionButton
							disabled={
								!motiveValue ||
								(showTextfield && otherMotive.trim().length < minLength)
							}
							onClick={() => handleSubmit()}
						>
							{isLoading ? "Enviando..." : "Enviar"}
						</S.ActionButton>
					</Grid>
				</Grid> */}
			</S.InfoContainer>


			<S.InfoContainer style={{ padding: '0px 10px' }}>
            <S.ConfirmationBox>
              {data.solicitarCodigoAutenticacao === true && (
                <>
                  <span className="confirmation-message">Campo para autenticação</span>
                  <ReactCodeInput
                    className="confirmation-box"
                    fields={4}
                    onChange={onChange}
                  />
                </>
              )}
              {data.botaoEnviar && (
                <S.ActionButton
                  variant="contained"
                  disabled={
                    !motiveValue ||
                    (showTextfield && otherMotive.trim().length < minLength)
                  }
                  onClick={() => handleSubmit()}
                >
                  {isLoading ? 'Confirmando...' : 'Confirmar'}
                </S.ActionButton>
              )}
            </S.ConfirmationBox>
          </S.InfoContainer>

		</S.RefuseContainer>
	);
};

export default RefuseConclusion;
